export function AccessDenied() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <h1>Woops...</h1>
      <p>You do not have access to this page.</p>
    </div>
  );
}
